import { PagingResultsViewModel } from '../../../core/_infrastructure/types/common';

export class InspectorExtranjeroItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: InspectorExtranjeroItemViewModel[];
}

export class InspectorExtranjeroItemViewModel {
    public Id: number;
    public Nombre: string = '';
    public Apellidos: string = '';
    public Habilitado: boolean = false;
    public IdPaisDescripcion: string;
}

export class InspectorExtranjeroViewModel {
    constructor() {}

    public Id: number;
    public Nombre: string = '';
    public Apellidos: string = '';
    public Habilitado: boolean = true;
    public IdPais: number = 0;
}
